/**
 * Views/Prenomina/ModalAgregarEmpleado.jsx
 *
 * Modal para agregar un empleado a la prenómina activa.
 * Solo muestra empleados que aún no están en la prenómina.
 *
 * `incluirBajas` (nómina histórica) también lista a los empleados dados de baja o
 * deshabilitados: una histórica carga un periodo que ya se pagó, y en él hay gente
 * que hoy ya no está en la empresa pero cuyos acumulados sí hacen falta.
 */

import React, { Component } from 'react'
import { Input, Tag } from 'antd'
import moment from 'moment'
import { ModalItem, ButtonItem } from '../../../../Components/Items'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'

class ModalAgregarEmpleado extends Component {

  state = { busqueda: '', agregando: null }

  filtrarEmpleados() {
    const { empleados, empleadosEnPrenomina, incluirBajas } = this.props
    const { busqueda } = this.state

    return empleados.filter(e => {
      if (empleadosEnPrenomina.has(e._id)) return false
      // El catálogo llega completo desde datosParaPrenomina; los no activos sólo se
      // ofrecen en una histórica (el backend rechaza lo contrario de todos modos).
      if (!incluirBajas && e.estado !== 1) return false
      // Las fichas incompletas del alta por pasos no entran a ninguna nómina.
      if (e.estado === 3) return false
      if (!busqueda) return true
      // El código se incluye crudo y rellenado con ceros para que dé lo mismo teclear
      // "12" o "0012" (en la lista se ve rellenado).
      const cod = e.codigo == null ? '' : String(e.codigo)
      const texto = `${cod} ${cod.padStart(4, '0')} ${e.apellidoPaterno} ${e.apellidoMaterno} ${e.nombre} ${e.rfc}`.toLowerCase()
      return texto.includes(busqueda.toLowerCase())
    })
  }

  async handleAgregar(id) {
    this.setState({ agregando: id })
    await this.props.onAgregar(id)
    this.setState({ agregando: null })
  }

  render() {
    const { visible, onClose, incluirBajas } = this.props
    const { busqueda, agregando } = this.state
    const filtrados = this.filtrarEmpleados()

    return (
      <ModalItem
        title="Agregar empleado a la prenómina"
        visible={visible}
        spinning={false}
        onCancel={onClose}
        footer={null}
        width={560}
      >
        <Input
          prefix={<SearchOutlined style={{ color: '#bbb' }} />}
          placeholder="Buscar por código, nombre o RFC..."
          value={busqueda}
          onChange={e => this.setState({ busqueda: e.target.value })}
          style={{ marginBottom: 12 }}
          autoFocus
        />

        <div style={{ maxHeight: 420, overflowY: 'auto' }}>
          {filtrados.length === 0 && (
            <div style={{ color: '#aaa', textAlign: 'center', padding: 32 }}>
              Sin empleados disponibles
            </div>
          )}
          {filtrados.map(e => (
            <div
              key={e._id}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '8px 12px', borderBottom: '1px solid #f0f0f0',
              }}
            >
              <div>
                <div style={{ fontWeight: 500, fontSize: 13 }}>
                  {e.apellidoPaterno} {e.apellidoMaterno} {e.nombre}
                  {e.estado !== 1 && (
                    <Tag color="default" style={{ fontSize: 10, marginLeft: 6 }}>
                      {e.fechaBaja
                        ? `baja ${moment.utc(e.fechaBaja).format('DD/MM/YYYY')}`
                        : 'deshabilitado'}
                    </Tag>
                  )}
                </div>
                <div style={{ fontSize: 11, color: '#aaa' }}>
                  {e.codigo != null && (
                    <>{String(e.codigo).padStart(4, '0')} · </>
                  )}
                  {e.rfc}
                </div>
              </div>
              <ButtonItem
                size="small"
                icon={<PlusOutlined />}
                loading={agregando === e._id}
                disabled={agregando !== null}
                onClick={() => this.handleAgregar(e._id)}
              >
                Agregar
              </ButtonItem>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 12, fontSize: 11, color: '#aaa' }}>
          Solo se muestran empleados que aún no están en esta prenómina.
          {incluirBajas
            ? ' Por ser una nómina histórica también aparecen los que ya están dados de baja.'
            : ''}
        </div>
      </ModalItem>
    )
  }
}

export default ModalAgregarEmpleado